window.get_discount = '';
window.appliedProductDiscount = null;

async function fetchCart() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`Cart failed: ${response.status}`);
    return await response.json();
  } catch (err) {
    console.error('Cart.js error:', err);
    return null;
  }
}

async function fetchDiscount(discountCode) {
  try {
    const response = await fetch(
      'https://integrations.playermaker.co.uk/webhook/pm-discount-data-v2',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: discountCode }),
      }
    );
    return await response.json();
  } catch (err) {
    console.error('Discount webhook error:', err);
    return null;
  }
}

function formatMoneyWithoutCents(cents) {
  return Shopify.formatMoney(cents, window.Money_Filter)
    .replace(',00', '')
    .replace('.00', '');
}

function getProductPriceElements() {
  return document.querySelectorAll('.price_main_product, .price_main_product_discount');
}

function normalizePercentage(value) {
  const pct = parseFloat(value);
  if (isNaN(pct)) return null;
  return pct > 1 ? pct / 100 : pct;
}

function isFixedAmountDiscount(discount) {
  if (!discount) return false;
  return discount.type === 'fixed' || discount.type === 'fixed_amount';
}

function isPercentageDiscount(discount) {
  return discount?.type === 'percentage';
}

function parseDiscountFromLiquidMeta() {
  const el = document.getElementById('pm-active-discount-meta');
  if (!el?.textContent) return null;

  try {
    const meta = JSON.parse(el.textContent);
    if (!meta?.type) return null;

    if (meta.type === 'fixed_amount' || meta.type === 'fixed') {
      const value = parseFloat(meta.value);
      if (Number.isNaN(value) || value <= 0) return null;
      return { type: 'fixed', value, appliesOnEachItem: meta.appliesOnEachItem !== false };
    }

    if (meta.type === 'percentage') {
      const normalized = normalizePercentage(meta.value);
      if (normalized == null) return null;
      return { type: 'percentage', value: normalized };
    }
  } catch (err) {
    console.warn('pm-active-discount-meta parse failed', err);
  }

  return null;
}

function mergeDiscountSources(webhookDiscount, cartDiscount, liquidDiscount) {
  if (isFixedAmountDiscount(webhookDiscount)) return webhookDiscount;
  if (isFixedAmountDiscount(liquidDiscount)) return liquidDiscount;
  if (isFixedAmountDiscount(cartDiscount)) return cartDiscount;
  return webhookDiscount || liquidDiscount || cartDiscount || null;
}

function parseDiscountFromResponse(response) {
  const value = response?.discount?.[0]?.discount?.customerGets?.value;
  if (!value) return null;

  const amount = value?.amount?.amount;
  if (
    value.__typename === 'DiscountAmount' ||
    (amount != null && parseFloat(amount) > 0)
  ) {
    const parsedAmount = parseFloat(amount);
    if (!Number.isNaN(parsedAmount) && parsedAmount > 0) {
      return {
        type: 'fixed',
        value: parsedAmount,
        appliesOnEachItem: value.appliesOnEachItem !== false,
      };
    }
  }

  if (value.percentage != null && value.percentage !== '') {
    const normalized = normalizePercentage(value.percentage);
    if (normalized == null || normalized <= 0) return null;
    return { type: 'percentage', value: normalized };
  }

  return null;
}

function parseDiscountFromCart(cartData) {
  if (!cartData) return null;

  let fixedAmount = null;
  let percentage = null;
  let appliesOnEachItem = true;

  for (const item of cartData.items || []) {
    for (const allocation of item.line_level_discount_allocations || []) {
      const application = allocation.discount_application;
      if (!application) continue;

      if (application.value_type === 'fixed_amount' || application.value_type === 'fixed') {
        fixedAmount = parseFloat(application.value);
        appliesOnEachItem = true;
      } else if (application.value_type === 'percentage') {
        percentage = parseFloat(application.value);
      }
    }
  }

  for (const application of cartData.cart_level_discount_applications || []) {
    if (application.value_type === 'fixed_amount' || application.value_type === 'fixed') {
      fixedAmount = parseFloat(application.value);
      appliesOnEachItem = application.target_type === 'line_item';
    } else if (application.value_type === 'percentage') {
      percentage = parseFloat(application.value);
    }
  }

  if (fixedAmount != null && !Number.isNaN(fixedAmount) && fixedAmount > 0) {
    return { type: 'fixed', value: fixedAmount, appliesOnEachItem };
  }

  if (percentage != null && !Number.isNaN(percentage) && percentage > 0) {
    const normalized = normalizePercentage(percentage);
    if (normalized != null) {
      return { type: 'percentage', value: normalized };
    }
  }

  return null;
}

function getQuantityMultiplier() {
  const qtyInput = document.querySelector('.total_price .quantity__input, .first-step .quantity__input');
  const qty = parseInt(qtyInput?.value, 10);
  return qty > 0 ? qty : 1;
}

function showDiscountBadges() {
  document.querySelectorAll('.first-step-total-price-discount').forEach((el) => {
    el.classList.add('flex-discount');
  });
  document.querySelectorAll('.compare-price[data-compare-price]').forEach((compareEl) => {
    const compareAtCents = Math.round(parseFloat(compareEl.dataset.comparePrice) || 0);
    if (!compareAtCents) return;
    const priceWrap = compareEl.closest('.cart_discount_main');
    if (priceWrap) {
      priceWrap.classList.add('flex-discount', 'has-compare-at');
    }
  });
  document.body.classList.add('has-discount-code');
}

function updateStickyButtonDiscounts(text) {
  document.querySelectorAll('.sticky-add-to-cart-btn .select-membership-cart-discount').forEach((el) => {
    el.innerHTML = text;
    el.style.display = '';
  });
}

function updateOtherButtonDiscounts(text) {
  document.querySelectorAll('.select-membership-cart-discount').forEach((el) => {
    if (!el.closest('.sticky-add-to-cart-btn') && !el.closest('cart-drawer')) {
      el.innerHTML = text;
      el.style.display = '';
    }
  });
}

function updateDiscountBadgeValues(value, isPercentage) {
  document.querySelectorAll('.select-membership-cart-discount-main .discount_value').forEach((discountEl) => {
    discountEl.innerHTML = isPercentage ? `${value}%` : value;
  });
}

function getCatalogUnitCentsFromDom() {
  const mainPriceEl =
    document.querySelector('.total_price .price_main_product') ||
    document.querySelector('.first-step-total-price .price_main_product');
  return Math.round(parseFloat(mainPriceEl?.dataset.price) || 0);
}

function getCompareAtUnitCentsFromDom() {
  const selectors = [
    '.total_price .compare-price[data-compare-price]',
    '.first-step-total-price .compare-price[data-compare-price]',
    '.price_warp .compare-price[data-compare-price]',
    '.sticky-container .compare-price[data-compare-price]',
  ];

  for (const selector of selectors) {
    const el = document.querySelector(selector);
    const cents = Math.round(parseFloat(el?.dataset.comparePrice) || 0);
    if (cents > 0) return cents;
  }

  return 0;
}

function ensureCompareForCodeDiscount(quantity) {
  const qty = quantity > 0 ? quantity : 1;

  document
    .querySelectorAll('.total_price .price_main_product, .sticky-add-to-cart-btn .price_main_product')
    .forEach((priceEl) => {
      const catalogCents = Math.round(parseFloat(priceEl.dataset.price) || 0);
      if (!catalogCents) return;

      const container =
        priceEl.closest('.cart_discount_main') ||
        priceEl.closest('.first-step-total-price') ||
        priceEl.closest('.price_warp') ||
        priceEl.closest('.total_price');

      if (!container) return;

      let compareEl = container.querySelector('.compare-price');
      const existingCompareCents = Math.round(parseFloat(compareEl?.dataset.comparePrice) || 0);
      const hasMerchandisingCompare = existingCompareCents > 0 && compareEl?.dataset.codeCompare !== 'true';

      if (hasMerchandisingCompare) {
        container.classList.add('flex-discount', 'has-compare-at');
        return;
      }

      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'compare-price';
        priceEl.parentNode.insertBefore(compareEl, priceEl);
      }

      compareEl.dataset.comparePrice = String(catalogCents);
      compareEl.dataset.codeCompare = 'true';
      compareEl.innerHTML = formatMoneyWithoutCents(catalogCents * qty);

      const flexHost =
        priceEl.closest('.cart_discount_main') || priceEl.closest('.first-step-total-price') || container;
      flexHost.classList.add('flex-discount', 'has-compare-at');
    });
}

const PDP_COMPARE_PRICE_SELECTOR =
  '.total_price .compare-price[data-compare-price], .first-step-total-price .compare-price[data-compare-price], .price_warp .compare-price[data-compare-price], .sticky-container .compare-price[data-compare-price]';

function updateComparePrices(quantity, selector) {
  const qty = quantity > 0 ? quantity : 1;
  const compareNodes = document.querySelectorAll(selector || PDP_COMPARE_PRICE_SELECTOR);

  compareNodes.forEach((compareEl) => {
    if (compareEl.closest('cart-drawer')) return;

    const compareAtCents = Math.round(parseFloat(compareEl.dataset.comparePrice) || 0);
    if (!compareAtCents) return;
    compareEl.innerHTML = formatMoneyWithoutCents(compareAtCents * qty);
  });
}

function getDiscountedUnitCentsForBadge(discount) {
  const mainPriceEl = document.querySelector('.total_price .price_main_product');
  const catalogUnitCents = Math.round(parseFloat(mainPriceEl?.dataset.price) || 0);
  if (!catalogUnitCents || !discount) return 0;
  return calculateDiscountedUnitCents(catalogUnitCents, discount);
}

/** Shared savings label: catalog markdown first, coupon second. */
window.formatPrimeCouponBadge = function(compareCents, catalogCents, finalCents, quantity) {
  const qty = quantity > 0 ? quantity : 1;
  const primeCents = Math.max(0, compareCents - catalogCents) * qty;
  const couponCents = Math.max(0, catalogCents - finalCents) * qty;
  const parts = [primeCents, couponCents].filter((amount) => amount > 0);
  return parts.map(formatMoneyWithoutCents).join(' + ');
};

function updateDiscountBadgeFromCompare(quantity, discount) {
  const qty = quantity > 0 ? quantity : 1;
  const catalogUnitCents = getCatalogUnitCentsFromDom();
  const compareUnitCents = getCompareAtUnitCentsFromDom();
  const discountedUnitCents = getDiscountedUnitCentsForBadge(discount);
  if (!catalogUnitCents || !compareUnitCents || compareUnitCents <= discountedUnitCents) return false;
  const formatted = window.formatPrimeCouponBadge(compareUnitCents, catalogUnitCents, discountedUnitCents, qty);
  if (!formatted) return false;
  window.get_discount = (compareUnitCents - discountedUnitCents) * qty;
  const label = formatted + ' OFF';
  updateDiscountBadgeValues(formatted, false);
  updateStickyButtonDiscounts(label);
  updateOtherButtonDiscounts(label);
  return true;
}

function updateDiscountBadgeFromCode(discount, quantity) {
  const qty = quantity > 0 ? quantity : 1;

  if (updateDiscountBadgeFromCompare(qty, discount)) return;

  if (isFixedAmountDiscount(discount)) {
    const displayCents = getFixedDiscountDisplayCents(discount, qty);
    window.get_discount = displayCents;

    const formattedDiscount = formatMoneyWithoutCents(displayCents);
    const label = `${formattedDiscount} OFF`;
    updateDiscountBadgeValues(formattedDiscount, false);
    updateStickyButtonDiscounts(label);
    updateOtherButtonDiscounts(label);
    return;
  }

  const percentLabel = Math.round(discount.value * 100);
  window.get_discount = `${percentLabel}%`;
  const label = `${percentLabel}% OFF`;
  updateDiscountBadgeValues(percentLabel, true);
  updateStickyButtonDiscounts(label);
  updateOtherButtonDiscounts(label);
}

function getFixedDiscountDisplayCents(discount, quantity) {
  const qty = quantity > 0 ? quantity : 1;
  const rate = Shopify?.currency?.rate || 1;
  const perItemCents = Math.round(parseFloat(discount.value) * 100 * rate);
  const roundedPerItem = Math.round(perItemCents / 100) * 100;
  const multiplier = discount.appliesOnEachItem !== false ? qty : 1;
  return roundedPerItem * multiplier;
}

function getActiveProductDiscount(fallbackDiscount) {
  return window.appliedProductDiscount || fallbackDiscount || null;
}

function updateDiscountBadgeLabels(quantity, discount) {
  const qty = quantity > 0 ? quantity : 1;
  const active = getActiveProductDiscount(discount);
  if (!active) return;

  if (updateDiscountBadgeFromCompare(qty, active)) return;
  updateDiscountBadgeFromCode(active, qty);
}

function setPriceElementDiscountMeta(priceEl, discount) {
  if (isPercentageDiscount(discount)) {
    const percentLabel = Math.round(discount.value * 100);
    priceEl.setAttribute('data-percentage', 'percentage');
    priceEl.setAttribute('data-discount-type', 'percentage');
    priceEl.setAttribute('data-discount', String(percentLabel));
  } else {
    priceEl.removeAttribute('data-percentage');
    priceEl.setAttribute('data-discount-type', 'fixed');
    priceEl.setAttribute('data-discount', String(Math.round(discount.value)));
  }
}

function calculateDiscountedUnitCents(originalCents, discount) {
  if (isPercentageDiscount(discount)) {
    const discountCents = Math.round(originalCents * discount.value);
    const finalCents = Math.max(0, originalCents - discountCents);
    return Math.round(finalCents / 100) * 100;
  }

  const rate = Shopify?.currency?.rate || 1;
  const discountCents = Math.round(parseFloat(discount.value) * 100 * rate);
  const finalCents = Math.max(0, originalCents - discountCents);
  return Math.round(finalCents / 100) * 100;
}

function cityplayPage() {
  if (document.body.classList.contains('cityplay-product-page')) return true;
  for (const className of document.body.classList) {
    if (className.includes('cityplay')) return true;
  }
  return false;
}

function cityplayPriceElements() {
  return document.querySelectorAll(
    '.total_price .price_main_product, .price_warp .price_main_product, .sticky-container .price_main_product'
  );
}

function refreshProductDiscountPrices(quantity) {
  const discount = window.appliedProductDiscount;
  if (!discount) return;

  const qty = quantity || getQuantityMultiplier();
  ensureCompareForCodeDiscount(qty);

  const priceEls = cityplayPage() ? cityplayPriceElements() : getProductPriceElements();

  priceEls.forEach((priceEl) => {
    const originalCents = Math.round(parseFloat(priceEl.dataset.price) || 0);
    if (!originalCents) return;

    setPriceElementDiscountMeta(priceEl, discount);
    const unitCents = calculateDiscountedUnitCents(originalCents, discount);
    priceEl.innerHTML = formatMoneyWithoutCents(unitCents * qty);
  });

  const compareSelector = cityplayPage()
    ? '.total_price .compare-price[data-compare-price], .price_warp .compare-price[data-compare-price], .sticky-container .compare-price[data-compare-price]'
    : PDP_COMPARE_PRICE_SELECTOR;
  updateComparePrices(qty, compareSelector);

  updateDiscountBadgeLabels(qty, discount);
}

function applyDiscountUI(discount) {
  showDiscountBadges();

  if (isFixedAmountDiscount(discount)) {
    window.appliedProductDiscount = {
      type: 'fixed',
      value: parseFloat(discount.value),
      appliesOnEachItem: discount.appliesOnEachItem !== false,
    };
  } else if (isPercentageDiscount(discount)) {
    window.appliedProductDiscount = { type: 'percentage', value: discount.value };
  } else {
    return;
  }

  refreshProductDiscountPrices(getQuantityMultiplier());
}

async function initProductDiscountFromCart() {
  try {
    const liquidDiscount = parseDiscountFromLiquidMeta();
    const cartData = await fetchCart();
    if (!cartData) return;

    const discountObj = cartData.discount_codes?.[0];
    if (!discountObj) return;

    const response = await fetchDiscount(discountObj.code);
    const webhookDiscount = parseDiscountFromResponse(response);
    const cartDiscount = parseDiscountFromCart(cartData);
    const discount = mergeDiscountSources(webhookDiscount, cartDiscount, liquidDiscount);

    if (!discount) return;

    applyDiscountUI(discount);
  } catch (err) {
    console.error('Page error:', err);
  }
}

window.refreshProductDiscountPrices = refreshProductDiscountPrices;
window.applyDiscountUI = applyDiscountUI;

document.addEventListener('DOMContentLoaded', initProductDiscountFromCart);

document.addEventListener('DOMContentLoaded', () => {
  if (!cityplayPage() || window.appliedProductDiscount) return;
  const qtyInput = document.querySelector('.first-step .quantity__input');
  const qty = parseInt(qtyInput?.value, 10) || 1;
  if (qty > 1 && typeof window.renderCityplayProductPrices === 'function') {
    window.renderCityplayProductPrices(qty);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function') return;

  subscribe('quantity-update', () => {
    if (!window.appliedProductDiscount) return;
    refreshProductDiscountPrices(getQuantityMultiplier());
  });
});

window.addEventListener('load', () => {
  if (!window.appliedProductDiscount) return;
  refreshProductDiscountPrices(getQuantityMultiplier());
});
